import styled, {css} from 'styled-components';

export default function RouterButton({ children, gap, href, style, ...props }) {
    return (
        <RouterButtonStyle $gap={gap} {...props} href={href} target="_blank" style={{ ...style }}>
            {children}
        </RouterButtonStyle>
    );
}

const RouterButtonStyle = styled.a`
    text-decoration: none;
    color: #000000;
    display: flex;
    gap: 16px;
    width: fit-content;
    font-weight: 700;
    font-size: 22px;
    line-height: 1.36;
    border: none;
    background: none;
    cursor: pointer;
    align-items: center;
    text-align: left;
    text-decoration: underline;
    ${(props) =>
        props.$gap &&
        css`
            gap: ${({ $gap }) => `${$gap}px`};
        `}
`;
